module.exports = __webpack_public_path__ + "static/storesearch2-216b43845673ecae152d2cd1ce5df375.png";